/* ==========================================================================
   pdp-color-media.js: PDP-Bilder unterhalb der Galerie wechseln mit der Farbe
   --------------------------------------------------------------------------
   Gegenstueck zu snippets/pdp-color-image.liquid (N-tes Galerie-Bild der
   gewaehlten Farbe: FAQ-Karte, Vergleichs-Section, PDP Story ohne Bild je
   Farbe) und snippets/pdp-color-slot-image.liquid (Bild je Farbe aus dem
   Block: PDP Story Kapitel 1). Beide haengen bei mindestens zwei Farben
   die Bilddaten je Farbe an das <img> (pdp-color-image-tag.liquid):
     data-color-images = JSON { "<farb-handle>": { src, srcset, w, h, alt } }
     data-color-current = "<farb-handle>"
   Hier wird beim Farbwechsel in der HAUPT-Produktform src, srcset, width,
   height und alt getauscht. Fehlt die Farbe im JSON oder ist sie schon
   aktuell, bleibt das Bild unveraendert.

   Nur die Hauptform zaehlt: name passt auf /color|farbe/i (live DE
   "Farbe-1 ", EN "Color-1 ", jeweils mit Leerzeichen am Ende) UND das
   Attribut form ist "product-form-template--<id>__main". Die Quick-View-
   Instanzen (form="product-form-sections--<id>__quick-view") loesen nichts aus.

   Zusaetzlich beim Laden und bei shopify:section:load die gewaehlte Farbe
   der Hauptform lesen und anwenden (Formular-Wiederherstellung nach
   Zurueck-Navigation, Theme-Editor).

   Sets ohne Farb-Option (seit 29.10.26): fehlt ein Farbfeld in der
   Hauptform, gilt data-set-color am Haupt-<variant-selects>
   (data-section "template--<id>__main", product-variant-picker.liquid).

   Das Snippet bindet dieses Script je Bild ein, der Guard haengt die
   Listener nur einmal an. Kein resize-Listener (mobil feuert resize beim
   Ein- und Ausblenden der Browserleiste), keine Theme-Globals.
   ========================================================================== */
(function () {
  if (window.__tosColorMediaBound) return;
  window.__tosColorMediaBound = true;

  var NAME_RE = /color|farbe/i;
  var FORM_RE = /^product-form-template--.*__main$/;
  var MAIN_FIELDS =
    'input[form^="product-form-template--"][form$="__main"]:checked, ' +
    'select[form^="product-form-template--"][form$="__main"]';

  // Wie handleize() im Galerie-Filter (snippets/product-variant-options.liquid)
  function handleize(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isMainColorField(el) {
    if (!el || !el.getAttribute) return false;
    if (el.tagName !== 'INPUT' && el.tagName !== 'SELECT') return false;
    if (!NAME_RE.test(el.getAttribute('name') || '')) return false;
    return FORM_RE.test(el.getAttribute('form') || '');
  }

  function applyTo(img, handle) {
    if (img.getAttribute('data-color-current') === handle) return;
    var map;
    try {
      map = JSON.parse(img.getAttribute('data-color-images') || '');
    } catch (e) {
      return;
    }
    if (!map || typeof map !== 'object' || !Object.prototype.hasOwnProperty.call(map, handle)) return;
    var entry = map[handle];
    if (!entry || !entry.src) return;
    // srcset vor src: der Browser waehlt aus srcset, src ist nur der Rueckfall
    if (entry.srcset) {
      img.setAttribute('srcset', entry.srcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', entry.src);
    if (entry.w) img.setAttribute('width', entry.w);
    if (entry.h) img.setAttribute('height', entry.h);
    img.setAttribute('alt', entry.alt || '');
    img.setAttribute('data-color-current', handle);
  }

  function applyColor(handle) {
    if (!handle) return;
    var imgs = document.querySelectorAll('img[data-color-images]');
    for (var i = 0; i < imgs.length; i++) applyTo(imgs[i], handle);
  }

  function currentMainColor() {
    var fields = document.querySelectorAll(MAIN_FIELDS);
    for (var i = 0; i < fields.length; i++) {
      if (isMainColorField(fields[i])) return handleize(fields[i].value || '');
    }
    var sets = document.querySelectorAll('variant-selects[data-set-color]');
    for (var j = 0; j < sets.length; j++) {
      if (FORM_RE.test('product-form-' + (sets[j].getAttribute('data-section') || ''))) {
        return handleize(sets[j].getAttribute('data-set-color') || '');
      }
    }
    return '';
  }

  function sync() {
    applyColor(currentMainColor());
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!isMainColorField(t)) return;
    if (t.type === 'radio' && !t.checked) return;
    applyColor(handleize(t.value || ''));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
})();
